// 第三方 处方详情
import http from '../request';

const getPrescriptionDetail = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/mall-assistant/prescription/detailInOwn',
  data: params,
});

const getBuyDemandOrderFromIm = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/cloud-pharmacy/buyDemand/getBuyDemandOrderFromIm',
  data: params,
});

// 获取门店取药情况
const getRxUsedStatusApi = (params) => http({
  app: 'banyanSi',
  method: 'get',
  url: '/maserati/mp/prescription/rxSetlInfo',
  params: params,
});

export {
  getPrescriptionDetail,
  getBuyDemandOrderFromIm,
  getRxUsedStatusApi
};
